import { useState } from "react";
import { Link } from "react-router-dom";
import { List, Heart, MessageSquare, Plus } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { MyListings } from "../dashboard/DashboardTabs";
import { MyMessages } from "../dashboard/DashboardTabs";
import { MyFavorites } from "../dashboard/DashboardSimpleTabs";

/**
 * PrivatePanel — privater Bereich des vereinten Vermittler & Verkäufer-Dashboards.
 * Bündelt „Meine Inserate", „Favoriten" und „Nachrichten/Anfragen" — wiederverwendet
 * die bestehenden B2C-Dashboard-Komponenten. Phase 1 (Juni-2026).
 */
export default function PrivatePanel({ user }) {
    const [tab, setTab] = useState("listings");

    return (
        <div className="space-y-4" data-testid="vermittler-private-panel">
            <div className="flex items-center justify-between gap-3 flex-wrap">
                <p className="text-sm text-gray-600">
                    Ihre privaten Inserate, Favoriten und Nachrichten — wie im Privat-Dashboard.
                </p>
                <Link
                    to="/create-listing"
                    className="inline-flex items-center gap-1.5 px-3.5 h-10 rounded-sm bg-[#FFCC00] hover:bg-[#E6B800] text-[#111827] font-bold text-sm uppercase tracking-wider transition-colors"
                    data-testid="private-new-listing-btn"
                >
                    <Plus className="w-4 h-4" /> Neues Inserat
                </Link>
            </div>

            <Tabs value={tab} onValueChange={setTab} className="w-full">
                <TabsList className="inline-flex h-auto gap-1 bg-white border border-gray-200 rounded-sm p-1 flex-wrap">
                    <TabsTrigger value="listings" data-testid="private-tab-listings">
                        <List className="w-4 h-4 mr-1.5" /> Meine Inserate
                    </TabsTrigger>
                    <TabsTrigger value="favorites" data-testid="private-tab-favorites">
                        <Heart className="w-4 h-4 mr-1.5" /> Favoriten
                    </TabsTrigger>
                    <TabsTrigger value="messages" data-testid="private-tab-messages">
                        <MessageSquare className="w-4 h-4 mr-1.5" /> Nachrichten
                    </TabsTrigger>
                </TabsList>

                <TabsContent value="listings" className="mt-4" data-testid="private-content-listings">
                    <MyListings userId={user.id} />
                </TabsContent>
                <TabsContent value="favorites" className="mt-4" data-testid="private-content-favorites">
                    <MyFavorites />
                </TabsContent>
                <TabsContent value="messages" className="mt-4" data-testid="private-content-messages">
                    <MyMessages currentUser={user} />
                </TabsContent>
            </Tabs>
        </div>
    );
}
